import React from 'react';
type StaticPageHeaderProps = {
  title: string;
};

export default function StaticPageHeader({ title }: StaticPageHeaderProps) {
  return (
    <>
      <div className="busSeoWrap__cityTitle busSeoWrap__cityIndexTitle">
        <div className="makeFlex column appendTop15">
          <h1 className="font26 blackText latoBold appendBottom5">{title}</h1>
        </div>
      </div>
    </>
  );
}
